module.exports = __webpack_public_path__ + "static/banner2-0cfdf240701c3b77208ce9290e4dfa81.png";